// VH-284: "device and browser" for the open sessions list, from the browser's
// own description. A plain reading, not a fingerprint: it only has to let a
// person tell their phone from their laptop.

const SYSTEMS = [
  [/iPhone/i, 'iPhone'],
  [/iPad/i, 'iPad'],
  [/Android/i, 'Android'],
  [/Windows/i, 'Windows'],
  [/Mac OS X|Macintosh/i, 'Mac'],
  [/CrOS/i, 'ChromeOS'],
  [/Linux/i, 'Linux'],
]

// Order matters: Edge and Opera also say "Chrome", Chrome also says "Safari".
const BROWSERS = [
  [/Edg\//i, 'Edge'],
  [/OPR\/|Opera/i, 'Opera'],
  [/Firefox\/|FxiOS/i, 'Firefox'],
  [/Chrome\/|CriOS/i, 'Chrome'],
  [/Safari\//i, 'Safari'],
]

const first = (pairs, text) => pairs.find(([pattern]) => pattern.test(text))?.[1]

/** "Chrome on Windows", "Safari on iPhone", or null when nothing is known. */
export function describeUserAgent(userAgent) {
  if (!userAgent) return null
  const browser = first(BROWSERS, userAgent)
  const system = first(SYSTEMS, userAgent)
  if (browser && system) return `${browser} · ${system}`
  return browser || system || null
}
